import { ImportantDates } from "commonAssets/components/ImportantDates";
import { Page } from "commonAssets/pages/Page";
import { appLocale, outputDiv, i18n, userLanguage, siteInfo } from "../../../common/assets/js/constants";
import { createElement, loadingGif, toggleFieldError, validateField, modal, clearMessage } from "../../../common/assets/js/helpers";
// import { SubmitClaim } from "../../../common/assets/js/submit-claim";
import { SubmitClaim } from "commonAssets/components/Forms/SubmitClaim";

export class customPage extends Page {
    constructor(pages, slug, dates) {
        super(pages, slug, dates)
    }

    // This replace the standard claim form page.
    claimPage() {
        // Page row, columns and links.
        const page = createElement("div", {
            class: "row my-5",
        }, [
            createElement("div", {
                class: 'col-md-6 p-5 text-center',
                id: 'claim-form-consumer'
            }, [
                createElement("a", {
                    href: '/claim-form-consumer',
                    target: '_blank',
                    class: 'fw-bold fs-3'
                }, [], `<i class="bi bi-person-fill d-block fs-1"></i> Consumer Fix Claim Form`)
            ]),
            createElement("div", {
                class: 'col-md-6 p-5 text-center',
                id: 'claim-form-3rd-party'
            }, [
                createElement("a", {
                    href: '/claim-form-3rd-party',
                    target: '_blank',
                    class: 'fw-bold fs-3'
                }, [], `<i class="bi bi-people-fill d-block fs-1"></i> Third-Party Payor Fix Claim Form`)
            ]),
        ]);

        // Output the content
        outputDiv.appendChild(page)

        // Hide loading gif
        loadingGif(loading, "hide", 250)
    }

    // This replaces the contact page.
    contact() {
        const Pages = this.pages;
        Pages.forEach(page => {
            if (this.slug !== page.PageName) return;

            const PageTitle = createElement("h2", { id: "PageTitle" }, [page.PageTitle]);
            const Separator = createElement("hr");

            const adminData = page.PageContent[0];
            const Admin = createElement("address", { class: "mb-5" }, [
                createElement("span", { class: "fw-bold d-block", id: "adminTitle" }, [], adminData.AdminTitle),
                createElement("span", { class: "d-block", id: "adminName", }, [], adminData.AdminName),
                createElement("span", { class: "d-inline-block", id: "adminAddress1" }, [], adminData.AdminAddress1),
                adminData.AdminAddress2 ? createElement("span", { id: "adminAddress2" }, [], ', ' + adminData.AdminAddress2) : ``,
                createElement("br"),
                createElement("span", { class: "d-inline-block", id: "adminCity" }, [], adminData.AdminCity),
                createElement("span", { class: "d-inline-block pe-1", id: "adminState" }, [], ', ' + adminData.AdminState),
                createElement("span", { id: "adminZipCode" }, [], adminData.AdminZipCode),
                createElement("span", { class: "mt-3 d-block", id: "adminPhone" }, [], `<strong>${i18n.getTranslation('admin_phone')}</strong> <a href="tel:+${siteInfo.phone}">${siteInfo.phone}</a>`),
                createElement("span", { class: "d-block", id: "adminEmail" }, [], `<strong>${i18n.getTranslation('admin_email')}:</strong> <a href="mailto:${siteInfo.email_info}">${siteInfo.email_info}</a>`)
            ]);

            let Page = this;

            const Address = createElement("div", { class: "col-md-8" }, [Admin]);
            const Aside = createElement("div", { class: "col-md-4" }, [], Page.dates.card().outerHTML);
            const Row = createElement("div", { class: "row" }, [Address, Aside]);

            const pageElement = createElement("div", { class: "page" }, [PageTitle, Separator, Row]);
            outputDiv.appendChild(pageElement);
        });
        loadingGif(loading, "hide", 250);
    }
}